export default {
  namespaced: true,
  state: {
    paramsBasic: {
      gameType: 1,
      currentCompoent: 1
    },
    isDataManagement: false
  },
  getters: {
  },
  mutations: {
    setParamsBasic (state, paramsBasic) {
      state.paramsBasic = Object.assign({}, state.paramsBasic, paramsBasic)
    },
    setIsDataManagement (state, isDataManagement) {
      state.isDataManagement = isDataManagement
    }
  },
  actions: {
    setParamsBasicAction ({ commit }, paramsBasic) {
      commit('setParamsBasic', paramsBasic)
    },
    setIsDataManagement ({ commit }, isDataManagement) {
      commit('setIsDataManagement', isDataManagement)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/popoverPanel.js